import * as React from 'react';
import { EMPTY_ERROR_ARRAY, EMPTY_POLL_DATA } from '../../constants';
export const PollDataContext = React.createContext({
    pollData: EMPTY_POLL_DATA,
    setPollData: () => { },
    normalizedPollData: EMPTY_POLL_DATA,
    replaceOptionText: () => { },
    hasInputErrors: false,
    pollInputErrors: EMPTY_ERROR_ARRAY,
    togglePollInputError: () => { },
});
//# sourceMappingURL=poll-data-context.js.map